import { render, staticRenderFns } from "./MasterTahapan_magister.vue?vue&type=template&id=1eff86a6"
import script from "./MasterTahapan_magister.vue?vue&type=script&lang=js"
export * from "./MasterTahapan_magister.vue?vue&type=script&lang=js"
import style0 from "./MasterTahapan_magister.vue?vue&type=style&index=0&id=1eff86a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports